import { render } from "./ArticleSection.vue?vue&type=template&id=ee48459e&scoped=true"
import script from "./ArticleSection.vue?vue&type=script&lang=js"
export * from "./ArticleSection.vue?vue&type=script&lang=js"

import "./ArticleSection.vue?vue&type=style&index=0&id=ee48459e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee48459e"]])

export default __exports__